import axios from "@/utils/axios";
import config from "../../config";

const login = (data, config) => axios.post("/api/v1/pc/login", data, config);

const register = (data, config) =>
  axios.post("/api/v1/pc/register", data, config);

const changePassword = (data, config) =>
  axios.put("/api/v1/pc/setting/login/password", data, config);

const changePayPassword = (data, config) =>
  axios.put("/api/v1/pc/setting/pay/password", data, config);
const resetLoginPassword = (data, config) =>
  axios.post("/api/v1/pc/resetPassword", data, config);

const userInfo = (query, config) =>
  axios.get("/api/v1/pc/user/userInfo", query, config);
//获取积分列表
const selIntegralList = (data, config) =>
  axios.get("/api/v1/pc/user/integral/detailed", data, config);
//获取余额列表
const selBalanceConsumeList = (data, config) => axios.post("", data, config);

const selAddress = (data, config) =>
  axios.post("/api/v1/pc/setting/deliveryAddressNew", data, config);

const addAddress = (
  data = {
    addType: "1",
    contacts: "理解",
    contactPhone: "454455554",
    countryName: "澳洲",
    provinceName: "Perth ",
    cityName: " Bassendean ",
    areaName: " Eden Hill",
    addressDetail: "",
    zipCode: "110000,110200,110203"
  },
  config
) => axios.post("/api/v1/pc/setting/deliveryAddress", data, config);

const editAddress = (data = {}, config) =>
  axios.put("/api/v1/pc/setting/deliveryAddress", data, config);

const removeAddress = (addressId, query = {}, config) =>
  axios.remove(
    `/api/v1/pc/setting/deliveryAddress/${addressId}`,
    query,
    config
  );

const setDefaultAddress = (data = {}, config) =>
  axios.put("/api/v1/pc/setting/deliveryAddress/default", data, config);

const getRegisterCode = (data = {}, config) =>
  axios.post("/api/v1/pc/common/sendCode", data, config);

const scc = (data = {}, config) =>
  axios.post("/api/v1/pc/common/scc", data, config);
const rechange = (
  data = {
    channel: "",
    payType: "RoyalPay",
    rechargeAmount: "",
    source: "web"
  },
  config
) => axios.post("/api/v1/recharge", data, config);
export default {
  login,
  register,
  changePassword,
  changePayPassword,
  resetLoginPassword,
  userInfo,
  selIntegralList,
  selBalanceConsumeList,
  selAddress,
  addAddress,
  editAddress,
  removeAddress,
  setDefaultAddress,
  getRegisterCode,
  scc,
  rechange
};



// WEBPACK FOOTER //
// ./src/api/modules/user.js